import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OEPresentationSlideList from '../../controller/presentation/oe-presentation-slide-list';
import OEPresentationAnimationController from '../../controller/presentation/oe-presentation-animation-controller';
import retardUpdate from '../../../lib/react/update-retarder';

export default class OEPresentationSlideToolbar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this._shouldBeVisible = false;

        this.state = {};

        this.onActivePresentationChanged = this.onActivePresentationChanged.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);
    }

    shouldBeVisible()   {
        return this._shouldBeVisible;
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.defaultPresentation !== this.props.defaultPresentation)     {
            this.updateDefaultPresentation(nextProps);
        }

        if(nextProps.visible != this.props.visible && nextProps.visible) {
            this.updateDefaultPresentation(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.activePresentationChanged, this.onActivePresentationChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()  {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.activePresentationChanged, this.onActivePresentationChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    updateShouldBeVisible() {
        let shouldBeVisible = false;

        if(this.oe.isReady())   {
            var si = this.oe.sharedInterface, UIControllerType = this.oe.Module.UIControllerType;
            shouldBeVisible = si.getUIControllerVisible(UIControllerType.presentation) && !si.getUIControllerVisible(UIControllerType.media_center);
        }

        if(this._shouldBeVisible != shouldBeVisible) {
            this._shouldBeVisible = shouldBeVisible;
            if(this.props.onShouldBeVisibleChanged)  this.props.onShouldBeVisibleChanged(this, shouldBeVisible);
        }
    }

    updateDefaultPresentation(props) {
        if(!this.oe.isReady()) return;
        props = props || this.props; 
        let presController = this.oe.sharedInterface.getUIControllerPresentation();

        if(props.visible && this.shouldBeVisible && typeof(props.defaultPresentation) === 'number' && props.defaultPresentation >= 0 && presController.getActivePresentationID() < 0)    {
            presController.setActivePresentation(props.defaultPresentation)
            presController.apply(true);
        }
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.updateShouldBeVisible();
            return;
        }

        retardUpdate(this, () => {
            this.onActivePresentationChanged();
            this.updateShouldBeVisible();
        });
    }

    onActivePresentationChanged()   {
        // enable animation if a actual presentation is set
        this.oe.sharedInterface.getUIControllerPresentation().stopAnimation();
    }

    onUIControllerStateChanged(message, userInfo)    {
        this.updateShouldBeVisible();

        if(userInfo.type === this.oe.Module.UIControllerType.presentation) {
            this.updateDefaultPresentation();
        }
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <div className={'presentation-slide-toolbar ' + this.props.className}>
                    <OEPresentationSlideList
                        moduleId={this.props.moduleId}
                        className="view-bg std-border-color"
                        onlyPreviewSlides={true}
                    />

                    <OEPresentationAnimationController moduleId={this.props.moduleId} />
                </div>
                
            </React.Fragment>
        );
    }
}

OEPresentationSlideToolbar.defaultProps = {
    moduleId: '',
    className: '',
    defaultPresentation: null,
    visible: false
};

OEPresentationSlideToolbar.propTypes = {
    moduleId: PropTypes.string,
    className: PropTypes.string,
    visible: PropTypes.bool,
    onShouldBeVisibleChanged: PropTypes.func
};
